import { createRouter, createWebHashHistory } from "vue-router";
import Login from "../views/Login.vue";

const routes = [
  {
    path: "/",
    name: "login",
    component: Login,
  },
  {
    path: "/resetpwd",
    name: "restPwd",
    component: () => import("../views/ResetPwd.vue"),
  },
  {
    path: "/orderCompany",
    name: "orderCompany",
    component: () => import("../views/OrderCompany.vue"),
  },
  {
    path: "/detail",
    name: "detail",
    component: () => import("../views/OrderDetail.vue"),
  },
  {
    path: "/orderList",
    name: "orderList",
    component: () => import("../views/OrderList.vue"),
  },
  {
    path: "/applyFor",
    name: "applyFor",
    component: () => import("../views/ApplyFor.vue"),
  },
  {
    path: "/stopMealList",
    name: "stopMealList",
    component: () => import("../views/StopMealList.vue"),
  },
  {
    path: "/child",
    name: "child",
    component: () => import("../views/Child.vue"),
  },
  {
    path: "/user",
    name: "user",
    component: () => import("../views/User.vue"),
  },
  {
    path: "/about",
    name: "about",
    component: () => import("../views/About.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.fullPath === "/") {
    if (getQuery("child_id")) {
      localStorage.setItem("childId", getQuery("child_id"));
      localStorage.setItem("childName", getQuery("child_name"));
      localStorage.setItem("schoolName", getQuery("school_name"));
      localStorage.setItem("className", getQuery("class_name"));
    }
    if (localStorage.getItem("phone")) {
      next("/orderCompany");
    } else {
        next();
    }
  } else {
    next();
  }
});

/**
 * 获取url的query中的参数
 */
function getQuery(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return "";
}

export default router;
